<template>
  <div class="base-form-div">
    <el-form
      size="mini"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="是否启用" prop="name">
        <el-switch
          v-model="ruleForm.isUse"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="漫游时间(秒)">
        <el-input-number
          controls-position="right"
          :min="1"
          :step="0.5"
          v-model="ruleForm.time"
        ></el-input-number>
      </el-form-item>
      <div class="form-bottom">
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          :disabled="drawDone"
          @click="drawLine"
          >绘制</el-button
        >
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button class="base-button" size="mini" @click="resetForm('ruleForm')"
          >重置</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import DrawHelper from "../lib/DrawPolyline.js";
let DrawUti = undefined;
import * as Help from "./help";
let plotArr = [];
import DrawPolyline from "@/utils/cesiumBD/plot/DrawPolyline.js";
let DrawPolylineUti = undefined;
export default {
  props: ["subData"],
  data() {
    return {
      typeOptions: [],
      ruleForm: {
        isUse: false,
        time: 3,
        data: null,
      },
      rules: {},
      drawDone: false,
    };
  },
  created() {
    if (this.subData && this.subData.params && this.subData.params.type == "comRoam") {
      this.ruleForm = JSON.parse(JSON.stringify(this.subData.params.data));
      if (this.ruleForm.data) {
        let l = this.createLineEntity(this.ruleForm.data);
        plotArr.push(l);
        this.drawDone = true;
      }
    }
  },
  methods: {
    getPlot(plot) {
      var keyPos = plot.polyline.positions.getValue();
      if (keyPos.length < 1) {
        return;
      }
    },
    createLineEntity(positions) {
      var line = viewer.entities.add({
        show: true,
        polyline: {
          positions: positions,
          show: true,
          material: Cesium.Color.RED,
          width: 3,
          clampToGround: true,
          disableDepthTestDistance: Number.MAX_VALUE,
        },
      });
      return line;
    },
    drawLine() {
      if (!DrawPolylineUti) {
        DrawPolylineUti = new DrawPolyline({
          canEdit: true,
          callback: this.getPlot,
        });
      }

      DrawPolylineUti.reset();
      DrawPolylineUti.start();
      this.drawDone = true;
    },
    submitForm() {
      if (DrawPolylineUti && DrawPolylineUti.editHelp) {
        var keyPos = DrawPolylineUti.editHelp.plot.polyline.positions.getValue();
        DrawPolylineUti.editHelp.hideEdit();
        console.log(keyPos);
        this.ruleForm.data = keyPos;
      }
      this.subData.params.type = "comRoam";
      this.subData.params.data = this.ruleForm;
      this.$parent.close();
    },
    resetForm() {
      DrawPolylineUti && DrawPolylineUti.clear();
      this.ruleForm.data = null;
      this.drawDone = false;
      for (let i = 0; i < plotArr.length; i++) {
        viewer.entities.remove(plotArr[i]);
      }
    },
  },

  beforeDestroy() {
    DrawPolylineUti && DrawPolylineUti.clear();
    DrawPolylineUti = undefined;
    viewer.clock.multiplier = 1;
    for (let i = 0; i < plotArr.length; i++) {
      viewer.entities.remove(plotArr[i]);
    }
  },
};
</script>
<style>
.form-bottom {
  margin-bottom: 0 !important;
  text-align: center;
}

.el-input-number {
  width: 100%;
}
</style>
